var _rect, _path, _rect2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconTrashGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 35,
    viewBox: "0 0 32 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.39209,
    width: 32,
    height: 34.2154,
    rx: 10,
    fill: "#004A2F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.0339 14.4289C22.2073 14.4289 22.3646 14.5098 22.4889 14.6465C22.6047 14.7924 22.6631 14.9738 22.6462 15.1653C22.6462 15.2285 22.1827 21.4951 21.918 24.1328C21.7523 25.7515 20.7763 26.7342 19.3124 26.7612C18.1868 26.7882 17.0866 26.7975 16.0032 26.7975C14.8531 26.7975 13.7283 26.7882 12.6365 26.7612C11.2216 26.7249 10.2449 25.7245 10.0876 24.1328C9.81524 21.4858 9.36026 15.2285 9.3518 15.1653C9.34334 14.9738 9.40085 14.7924 9.51756 14.6465C9.63257 14.5098 9.79833 14.4289 9.97254 14.4289H22.0339ZM17.7953 8.20215C18.5641 8.20215 19.2508 8.77581 19.4495 9.59399L19.5916 10.2727C19.7066 10.8259 20.1548 11.2173 20.6707 11.2173H23.2061C23.5444 11.2173 23.826 11.5177 23.826 11.8998V12.2531C23.826 12.6259 23.5444 12.9355 23.2061 12.9355H8.79457C8.45545 12.9355 8.17383 12.6259 8.17383 12.2531V11.8998C8.17383 11.5177 8.45545 11.2173 8.79457 11.2173H11.33C11.845 11.2173 12.2932 10.8259 12.4091 10.2736L12.5419 9.63955C12.7482 8.77581 13.4273 8.20215 14.2045 8.20215H17.7953Z",
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.05,
    y: 0.39209,
    width: 32,
    height: 34.2154,
    rx: 8,
    fill: "#004A2F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTrashGreen);
export default __webpack_public_path__ + "static/media/IconTrashGreen.8d9dd97b8fb9e821becb0e83999ab1c1.svg";
export { ForwardRef as ReactComponent };